<template lang="pug">
  .sidebar-menu(ref="menu")
    ul.menu-items
      NavItem(
        v-for="(item,index) in navTree",
        :key="index",
        :item="item")
</template>

<script>
import { mapMutations } from 'vuex'
import IScroll from 'iscroll'
import NavItem from './NavItem'

export default {
  name: 'NavList',
  components: {
    NavItem
  },
  props: {
    navTree: Array
  },
  mounted () {
    this.$nextTick(() => {
      this.initScroll()
    })
  },
  updated () {
    this.initScroll()
  },
  data () {
    return {}
  },
  methods: {
    ...mapMutations([
      'changeHover'
    ]),
    initScroll () {
      if (this.menuScroll) {
        this.menuScroll.destroy()
        this.menuScroll = null
      }
      this.menuScroll = new IScroll(this.$refs.menu, {
        scrollbars: true,
        mouseWheel: true,
        interactiveScrollbars: true,
        shrinkScrollbars: 'scale',
        fadeScrollbars: true,
        click: true
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.sidebar-menu
  position: absolute
  overflow: hidden
  font-weight: normal
  z-index: 8
  .menu-items
    padding: 30px 0
.verticalBarClass
  background-color: #9cc5a1
.verticalBarInternalClass
  background-color: #216869
.content
  position: relative
  width: 320px
  height: 800px
  text-align: center
.el1
  height: 800px
  margin: 0 auto
.iScrollVerticalScrollbar
  background-color: #1E2028
</style>



// WEBPACK FOOTER //
// NavList.vue?42538fea